import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../config/config.service';
import { RetornoCusto } from '../types/RetornoCusto.type';

@Injectable({
  providedIn: 'root'
})
export class CustoService {

  constructor(private httpClient: HttpClient, private configService: ConfigService) { }

  // getRetornoCusto(instancia: string, data: Date){
  //     return this.httpClient.get<RetornoCusto[]>(`${this.configService.getApiUrlRoot()}/custos/?instancia=${instancia}&data=${data}`);
  //   }

  // postBuscarPims(instancia: string, dataInicial: Date, dataFinal: Date){
  //   return this.httpClient.post(`${this.configService.getApiUrlRoot()}/custos/pims?instancia=${instancia}&dataInicial=${dataInicial}&dataFinal=${dataFinal}`, null)
  // }

  // postEnviarErp(corpo: any){
  //   return this.httpClient.post(`${this.configService.getApiUrlRoot()}/custos/enviar-erp`, corpo)
  // }

  // postReverter(corpo: any){
  //   return this.httpClient.post(`${this.configService.getApiUrlIntegrador()}/custo/custos/reverter`, corpo)
  // }

  // exportar(corpo: any){
  //   return this.httpClient.post(`${this.configService.getApiUrlRoot()}/custos/relatorios/exportar`, corpo, { responseType: 'blob'})
  // }

  getRetornoCusto(instancia: string, data: Date){
      return this.httpClient.get<RetornoCusto[]>(`${this.configService.getWebApiUrlIntegrador()}/custo?instancia=${instancia}&data=${data}`);
    }

  postBuscarPims(instancia: string, dataInicial: Date, dataFinal: Date){
    return this.httpClient.post(`${this.configService.getApiUrlIntegrador()}/custo/custos?instancia=${instancia}&dataInicial=${dataInicial}&dataFinal=${dataFinal}`, null)
  }

  postEnviarErp(corpo: any){
    return this.httpClient.post(`${this.configService.getApiUrlIntegrador()}/custo/custos/enviaErp`, corpo)
  }

  postReverter(corpo: any){
    return this.httpClient.post(`${this.configService.getApiUrlIntegrador()}/custo/custos/reverter`, corpo)
  }

  exportar(corpo: any){
    return this.httpClient.post(`${this.configService.getApiUrlIntegrador()}/custo/custos/exportar`, corpo, { responseType: 'blob'})
  }
}
